import React from "react";
import { Box, Typography, Switch } from "@mui/material";

const Header = () => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
      <Box>
        <Typography variant="h4" fontWeight="bold">
          Intelli VKYC
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Secure Aadhaar, PAN & liveness verification
        </Typography>
      </Box>

      {/* <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="body2">Voice</Typography>
        <Switch defaultChecked={false} />
      </Box> */}
    </Box>
  );
};

export default Header;
